import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const ContentContext = createContext({ content: null, refresh: async () => {} });

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState(null);
  const [error, setError] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/content");
      setContent(data);
      setError(false);
    } catch {
      setError(true);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return <ContentContext.Provider value={{ content, error, refresh }}>{children}</ContentContext.Provider>;
};

export const useContent = () => useContext(ContentContext);
